export enum PaymentLeft {
  YES = 'Yes',
  NO = 'No, the trip is paid in full',
}
